import { render } from "./GameObject.vue?vue&type=template&id=6d485c99&scoped=true"
import script from "./GameObject.vue?vue&type=script&lang=js"
export * from "./GameObject.vue?vue&type=script&lang=js"

import "./GameObject.vue?vue&type=style&index=0&id=6d485c99&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d485c99"]])

export default __exports__